import { createApi } from '@reduxjs/toolkit/query/react';
import { createExtendedTokenBaseQuery } from './baseQuery';
import { ModelData } from '@/types/asset.types';

export const modelDataApi = createApi({
    reducerPath: 'modelDataApi',
    baseQuery: createExtendedTokenBaseQuery(''),
    tagTypes: ['ModelData'],
    endpoints: (builder) => ({
        getmodelData: builder.query<ModelData, {dropdown?: boolean} | void> ({
           query: (params) => ({
            url: '/master/models/',
            method: 'GET',
            params
           }),
           providesTags: ['ModelData'],
        }),

        // New dropdown-specific endpoint
        getModelDataDropdown: builder.query<ModelData, {dropdown?: boolean} | void> ({
           query: (params) => ({
            url: '/master/models/dropdown/',
            method: 'GET',
            params
           }),
           providesTags: ['ModelData'],
        }),
    })
})

export const {useGetmodelDataQuery, useGetModelDataDropdownQuery} = modelDataApi;